import { SelectionBarTemplete } from "@components/templates/SelectionBar/SelectionBar";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import CloudDownload from "@assets/images/icons/cloud_download.svg";
import Delete from "@assets/images/icons/delete.svg";
import More from "@assets/images/icons/more.svg";
import Exit from "@assets/images/icons/exit_to_app.svg";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { pendoEventType } from "@containers/TradeLanesBookmark/utils/constant";
import getTrackingEventDictionary from "@core/dictionary/tracking-event";
import { generateTrackingObject } from "@core/global/global-country-functions";

export const addToZoho = {
  icon: Exit,
  name: "Export to Zoho",
};

export const addToHubspot = {
  icon: Exit,
  name: "Export to Hubspot",
};

export const SelectionBar = ({ setShowFavModal, clearSelection, setShowDeleteModal, selectedCompanyArray, setDownloadModal, type }) => {
  const userDetails = useSelector((state) => state.userDetails);

  const selectionOptions = useMemo(() => {
    if (userDetails?.userData) {
      let selectionOptionsClone = [
        {
          icon: CloudDownload,
          name: "Download",
          cb: () => {
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_download", { ...generateTrackingObject(`intel-${type}-favourite`) });
            setDownloadModal(true);
          },
        },
        {
          icon: More,
          name: "Add Tags",
          cb: () => {
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_add_tags", { ...generateTrackingObject(`intel-${type}-favourite`) });
            setShowFavModal(true);
          },
        },
        {
          icon: Delete,
          name: "Remove",
          cb: () => {
            trademoTrackingEvents(getTrackingEventDictionary.dashboardFavourites + pendoEventType[type] + "bulk_delete", { ...generateTrackingObject(`intel-${type}-favourite`) });
            setShowDeleteModal(true);
          },
        },
      ];
      return selectionOptionsClone;
    }
  }, [userDetails]);

  return (
    <div className="d-inline-block mt-3">
      <SelectionBarTemplete type={type} options={selectionOptions} clearSelection={clearSelection} selectedCompanyArray={selectedCompanyArray} comingFrom={type} />
    </div>
  );
};
